import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading.component';

@NgModule({
  declarations: [],
  exports: [LoadingComponent],
  imports: [CommonModule, LoadingComponent],
})
export class FeaturesLoadingIndicatorModule {}
